<template>
  <div id="app">
    <!-- Render different layout based on the current route -->
    <div v-if="isLoginRoute">
      <router-view />
    </div>
    <div v-else-if="isRegisterRoute">
      <router-view />
    </div>
    <div v-else-if="isForgotPassword">
      <router-view />
    </div>
    <div v-else>
      <div class="container-scroller">
        <Sidebar />
        <div class="container-fluid page-body-wrapper">
          <Navbar />
          <div class="main-panel">
            <div class="content-wrapper">
              <router-view />
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from "./components/SidebarComponents.vue";
import Navbar from "./components/NavbarComponents.vue";
import Footer from "./components/FooterComponents.vue";
import "bootstrap";

export default {
  created() {
    document.title = "Gamiteam Dashboard";
    if (typeof document !== "undefined" && document.documentElement) {
      document.documentElement.setAttribute("lang", this.$currentLocale || "id");
    }
  },
  watch: {
    $currentLocale(newLocale) {
      if (typeof document !== "undefined" && document.documentElement && newLocale) {
        document.documentElement.setAttribute("lang", newLocale);
      }
    },
  },
  components: {
    Sidebar,
    Navbar,
    Footer,
  },
  computed: {
    isLoginRoute() {
      return this.$route.path === "/login";
    },
    isForgotPassword() {
      return (
        this.$route.path === "/forgotpassword" ||
        this.$route.path === "/forgot-password" ||
        this.$route.path === "/reset-password"
      );
    },
    isRegisterRoute() {
      return this.$route.path === "/register";
    },
  },
};
</script>

<style>
@import url("assets/style.css");
@import url("https://fonts.googleapis.com/css?family=Nunito");
@import url("https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css");
@import url("assets/vendors/css/vendor.bundle.base.css");
/* @import url('assets/vendors/mdi/css/materialdesignicons.min.css'); */

@import url("assets/vendors/select2/select2.min.css");
@import url("assets/vendors/select2-bootstrap-theme/select2-bootstrap.min.css");

@import url("dropify/dist/css/dropify.min.css");
@import url("assets/css/modern-vertical/style.css");
@import url("assets/css/shadcn.css");

:root, html {
  color-scheme: dark;
}

.text-muted {
  color: #94a3b8 !important;
}

a:focus-visible,
button:focus-visible,
input:focus-visible,
select:focus-visible,
textarea:focus-visible,
[tabindex]:focus-visible {
  outline: 2px solid #38bdf8 !important;
  outline-offset: 2px !important;
}

input[type="date"]::-webkit-calendar-picker-indicator {
  filter: invert(1);
}
</style>
